import React from 'react';
import { useTranslation } from 'react-i18next';
import type { MailMessage } from '@/types/mail';
import { sanitizeRichTextHtml } from '@/utils/html';
import { isBlank, stripHtml } from '@/utils/text';

interface Props {
  mail: MailMessage;
  html?: string;
}

export const MailReplyQuote: React.FC<Props> = ({ mail, html }) => {
  const { t } = useTranslation();

  const recipients = mail.recipients
    .map((recipient) => recipient.name)
    .join(', ');
  const details = [
    `${t('mail.composeModal.quote.from')} ${mail.senderName}`,
    `${t('mail.composeModal.quote.date')} ${mail.date}`,
    `${t('mail.composeModal.to')} ${recipients}`,
    `${t('mail.composeModal.subject')} ${mail.subject}`,
  ].join('\n');
  const body = html && !isBlank(stripHtml(html)) ? html : mail.body;

  return (
    <div className="flex flex-col gap-3 border-t border-divider pt-4 text-body-14 text-muted-foreground">
      <p className="whitespace-pre-line">{details}</p>
      <div
        className="rich-text"
        dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(body) }}
      />
    </div>
  );
};
